export const DIALOG_TYPE = Object.freeze({
  ERROR: 'error',
  SUCCESS: 'success',
  CONFIRMATION: 'confirmation',
  SYSTEM: 'system'
})
